module.exports = __webpack_public_path__ + "static/EGO_x1-771ee99f74676470ecd3d23a78e80098.png";